export default {
	UseMajorFraction:'useMajorFraction',
	OffersScholarship:'offersScholarship',
	AdvancerPolicy:'advancerPolicy',
	IncludeEnhancedAdvancerRatio:'includeEnhancedAdvancerRatio',
	SmartProviderId:'smartProviderId',
	PremierEvent:'premierEvent'
};




// WEBPACK FOOTER //
// ./src/containers/event/components/setup/fields.js